var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import EditIcon from "@mui/icons-material/Edit";
import InfoIcon from "@mui/icons-material/Info";
import { Box, IconButton, Paper, Popover, Stack, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { COMMON_PREFERENCE_TYPES } from "../../../models/profile/preference.model";
import { getProfileInterests } from "../../../utils/profile.util";
import { labelizeUnderScoreText, useLocalize } from "../../../utils/text.util";
import { ElementChip } from "../../uiElements/base/ElementChip";
import { ElementChipList } from "../../uiElements/base/ElementChipList";
import { InterestElement } from "../../uiElements/InterestElement";
import ProfileQuickPreferenceEditor from "../ProfileQuickPreferenceEditor";
var ProfileInterests = function (_a) {
    var profile = _a.profile, setProfile = _a.setProfile, voiceNoteId = _a.voiceNoteId;
    var t = useTranslation().t;
    var tFallback = useLocalize().tFallback;
    var voiceNoteChipRef = useRef(null);
    useEffect(function () {
        var timeout = setTimeout(function () {
            if (voiceNoteChipRef.current) {
                voiceNoteChipRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        }, 300);
        return function () { return clearTimeout(timeout); };
    }, []);
    var _b = useState(null), anchorElPreferences = _b[0], setAnchorElPreferences = _b[1];
    var openPreferenceEditor = Boolean(anchorElPreferences);
    var handleEditInterests = function (event) {
        setAnchorElPreferences(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorElPreferences(null);
    };
    var interests = getProfileInterests(profile);
    var highlightedInterestIndex = voiceNoteId
        ? interests.findIndex(function (interest) { return interest.voiceNoteId === voiceNoteId; })
        : -1;
    var interestElements = interests.map(function (interest, index) {
        var isActive = Boolean(voiceNoteId) && interest.voiceNoteId === voiceNoteId;
        return (_jsx(Box, __assign({ ref: index === highlightedInterestIndex ? voiceNoteChipRef : undefined, sx: { display: 'inline-flex', minWidth: 0, maxWidth: '100%' } }, { children: _jsx(InterestElement, { label: tFallback("".concat(interest.preferenceType, "_").concat(interest.preferenceValue), labelizeUnderScoreText(interest.preferenceValue)), value: interest.preferenceValue, aiGenerated: interest.preferenceType === COMMON_PREFERENCE_TYPES.CRQLAR_AI_GENERATED_INTERESTS, active: isActive }) }), "".concat(interest.preferenceType, "-").concat(interest.preferenceValue, "-").concat(index)));
    });
    return (_jsxs(_Fragment, { children: [_jsxs(Stack, __assign({ gap: 1, mt: 2 }, { children: [_jsx(Typography, __assign({ variant: 'subtitle1', fontWeight: 500 }, { children: t('Interests') })), _jsxs(ElementChipList, { children: [interestElements.length === 0 && (_jsx(ElementChip, { text: t('No interests found'), startIcon: _jsx(InfoIcon, { sx: { fontSize: 15, color: 'text.secondary' } }), disabled: true })), interestElements, _jsx(Box, { children: _jsx(IconButton, __assign({ size: 'small', color: 'primary', onClick: handleEditInterests }, { children: _jsx(EditIcon, { sx: { fontSize: '14px' } }) })) })] })] })), _jsx(Popover, __assign({ open: openPreferenceEditor, anchorEl: anchorElPreferences, onClose: handleClose, anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                } }, { children: _jsx(Paper, __assign({ sx: { p: 2, minWidth: '300px', maxWidth: '1000px' } }, { children: _jsx(ProfileQuickPreferenceEditor, { profile: profile, setProfile: function (p) {
                            setProfile(p);
                            handleClose();
                        }, open: openPreferenceEditor, preferenceTypes: [COMMON_PREFERENCE_TYPES.CRQLAR_INTERESTS] }) })) }))] }));
};
export default ProfileInterests;
